/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Header from '../../components/Header'
import Footer from '../../components/footer'
import { get } from '../../services/https'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useParams } from 'react-router'
import { useNavigate, useLocation } from 'react-router-dom'
import { baseUrl } from '../../services/base'
import { ToRial } from '../../services/money'

import PicProduct from '../../assets/pictures/Picture.jpg'

export default function index() {
  const { id } = useParams()
  const navigate = useNavigate()

  const [food, setFood] = useState({
    name: 'عنوان محصول',
    price: '0',
    discountPrice: '0',
    pic: PicProduct,
    description: '...',
    status: true
  })

  const [userInfo ,setUserInfo] = useState();
  const location = useLocation()

  useEffect(() => {
    get(`/api/front/foods/${id}`)
      .then(response => {
        setFood({
          name: response.data.data[0].name,
          price: ToRial(response.data.data[0].price),
          discountPrice: ToRial(response.data.data[0].discountPrice),
          pic: `${baseUrl.base}${response.data.data[0].pic}`,
          description: response.data.data[0].description,
          status: response.data.data[0].status
        })
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    if (location.state){
      const {userInfo} = location.state;
      setUserInfo(userInfo)
    }
  }, [id, location.state])

  return (
    <div id='menu'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className="scroll">
        <div>
          <div className='singleFood'>
            <div className='singleFoodBody'>
              <div className='singleFoodPic'>
                <img src={food.pic} alt='pic' />
                <span className='hasBeen' style={food.status ? {display: 'none'} : {display: ''}}>ناموجود</span>
              </div>
              <div className='singleFoodTitle'>
                {food.name}
              </div>
              <div className='singleFoodSubitle'>
                {food.description}
              </div>
              <div className='singleFoodDetail' style={food.status ? { display: '' } : { display: 'none' }}>
                <span style={food.discountPrice != 0 ? { fontSize: '12px', textDecoration: 'line-through' } : {}}>{food.price} تومان</span>
                <span style={food.discountPrice == 0 ? { display: 'none' } : {}}>{food.discountPrice} تومان</span>
                <span className='singleFoodAdd' style={{ display : 'none' }}></span>
              </div>
              <button className='singleFoodButton' onClick={() => {
                if (localStorage.getItem('shopId') !== null) {
                  navigate('/menu', { state: location.state })
                } else {
                  navigate('/')
                }
              }}>
                بازگشت به منو
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer page={''} />
    </div>
  )
}
